import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GarageVehicleMapper } from "../mappings/garage-vehicle.mapping";
import { IGarageVehicleModel } from "../models/garage/garage-vehicle.model";
import { IPaginationRequestBaseModel } from "../models/generic/pagination/pagination-request.base.model";
import { IPaginationResponseModel } from "../models/generic/pagination/pagination-response.base.model";
import { IGarageVehicleDtoModel } from "../models/garage/dto/garage-vehicle-dto.model";
import { IMarqueVehicleDtoModel } from "../models/vehicles/dto/marque-dto.model";
import { EnvironmentService } from "./environment.service";
import { ApplicationContextService } from "./application-context.service";
import { CoreService } from "./customer-core.service";

@Injectable({
   providedIn: 'root'
})
export class GarageService {
   mapper: GarageVehicleMapper;
   constructor(private readonly httpClient: HttpClient, private envService: EnvironmentService, private applicationContext: ApplicationContextService, private customerService: CoreService) {
      this.mapper = new GarageVehicleMapper();
   }

   private path() {
      if (this.applicationContext.isPublic()) {
         return `${this.envService.settings.publicApiUrl}/Customers/vehicles`;
      }
      return `${this.envService.settings.apiUrl}/Garages`;
   }

   getAll(paginationModel: IPaginationRequestBaseModel): Observable<IPaginationResponseModel<IGarageVehicleModel>> {
      throw new Error("Method not implemented.");
   }

   public delete(model: IGarageVehicleModel): Observable<boolean> {
      const httpOptions = {
         headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
            customerId: this.customerService.getCustomerId(model.customerId),
            customerVehicleIds: [model.id]
         }
      };
      return this.httpClient.delete<boolean>(`${this.path()}${this.applicationContext.isPublic() ? '?customerId=' + this.customerService.getCustomerId(model.customerId) : ''}`, httpOptions);
   }

   public get(vehicleId: string, customerId: string): Observable<IGarageVehicleModel> {
      return this.httpClient.get<IGarageVehicleDtoModel>(`${this.path()}/${vehicleId}${this.applicationContext.isPublic() ? '?customerId=' + this.customerService.getCustomerId(customerId) : ''}`).pipe(
         map(resultDto => this.mapper.toApplicationModel(resultDto))
      );
   }

   public update(model: IGarageVehicleModel, vehicleId: string, customerId: string): Observable<IGarageVehicleModel> {
      const dto = {
         customerId: this.customerService.getCustomerId(customerId),
         customerVehicleId: vehicleId,
         displayName: model.displayName,
         vehicleId: model.vehicleId,
         year: model.year,
         registrationNumber: model.registrationNumber,
         engineNumber: model.engineNumber,
         chassisNumber: model.chassisNumber,
         vehicleIdentificationNumber: model.vehicleIdentificationNumber,
         notes: model.notes,
         isDefault: model.isDefault
      };
      return this.httpClient.put<IGarageVehicleDtoModel>(`${this.path()}/${vehicleId}${this.applicationContext.isPublic() ? '?customerId=' + this.customerService.getCustomerId(customerId) : ''}`, dto).pipe(
         map(resultDto => this.mapper.toApplicationModel(resultDto))
      )
   }

   public save(model: IGarageVehicleModel, customerId: string): Observable<IGarageVehicleModel> {
      const dto = {
         customerId: this.customerService.getCustomerId(customerId),
         displayName: model.displayName,
         vehicleId: model.vehicleId,
         year: model.year,
         registrationNumber: model.registrationNumber,
         engineNumber: model.engineNumber,
         chassisNumber: model.chassisNumber,
         vehicleIdentificationNumber: model.vehicleIdentificationNumber,
         notes: model.notes,
         isDefault: model.isDefault
      };
      return this.httpClient.post<IGarageVehicleDtoModel>(`${this.path()}${this.applicationContext.isPublic() ? '?customerId=' + this.customerService.getCustomerId(customerId) : ''}`, dto).pipe(
         map(resultDto => this.mapper.toApplicationModel(resultDto))
      )
   }

   public getCustomerVehicles(customerId: string): Observable<IPaginationResponseModel<IGarageVehicleModel>> {
      return this.httpClient.get<IGarageVehicleDtoModel[]>(`${this.path()}?customerId=${this.customerService.getCustomerId(customerId)}`).pipe(
         map(dtos => this.mapper.toApplicationModels(dtos)),
         map(models => {
            return {
               total: models.length,
               data: models
            } as IPaginationResponseModel<IGarageVehicleModel>
         })
      );
   }
}